import React from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AiAssistNote = ({ result }) => {
  if (!result) return null;
  if (result.configured === false) {
    return (
      <Alert variant="warning">
        {result.message || 'AI is not configured.'}{' '}
        <Link to="/apps/tender/settings/ai">Open AI settings</Link>.
      </Alert>
    );
  }
  if (!result.message) return null;
  return <Alert variant={result.failed ? 'danger' : 'info'}>{result.message}</Alert>;
};

export default AiAssistNote;
